import { Group, MultiSelect } from '@mantine/core';
import { useUnit } from 'effector-react';
import {
    payoutTicketPriorities,
    type PayoutTicketPriority,
    type PayoutTicketStatus,
    payoutTicketStatuses,
} from '~/entities/payout';
import { $ticketsFilter, setTicketsFilter } from '../model';

export const TicketsFilter = () => {
    const filter = useUnit($ticketsFilter);

    return (
        <Group>
            <MultiSelect
                flex={1}
                size='xs'
                label='Статус'
                value={filter.statuses}
                placeholder='Выберите статус'
                data={payoutTicketStatuses}
                onChange={(s) => setTicketsFilter({ statuses: s as PayoutTicketStatus[] })}
            />

            <MultiSelect
                flex={1}
                size='xs'
                label='Приоритет'
                value={filter.priorities}
                placeholder='Выберите приоритет'
                data={payoutTicketPriorities}
                onChange={(p) => setTicketsFilter({ priorities: p as PayoutTicketPriority[] })}
            />
        </Group>
    );
};
